import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";

function About() {
  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "left", padding: "90px" }}>
          <Col
            md={10}
            style={{
              justifyContent: "justifyContent",
              paddingTop: "30px",
              paddingBottom: "50px",
            }}
          >
            <p style={{ textAlign: "left" }}>
              <a href="https://top.gg/bot/943033915600404512">
                <img src="https://top.gg/api/widget/servers/943033915600404512.svg"/>
              </a>
            </p>
            <p style={{ textAlign: "center" }}>
              <p className="home-about-body"><span className="purple">Status:</span></p>
              <ul>
                <li className="about-activity">
                  Cosmos is <span className="green">ONLINE</span>.
                </li>
              </ul>
            </p>
          <p style={{ textAlign: "center" }}>
            <p className="home-about-body"><span className="purple">News:</span></p>
            <ul>
              <li className="about-activity">
                 <span className="purple">11/06/2023: </span> Lost the domain due to financial issues.
              </li>
              <li className="about-activity">
                 <span className="purple">10/07/2022: </span> Migrated from discord.py to nextcord.
              </li>
              <li className="about-activity">
                 <span className="purple">11/05/2022: </span> The website got a domain!
              </li>
              <li className="about-activity">
                 <span className="purple">03/05/2022:</span> Swithced to slash commands!
              </li>
              <li className="about-activity">
                 <span className="purple">02/05/2022:</span> Discord has officially verified Cosmos!
              </li>
              <li className="about-activity">
                 <span className="purple">27/04/2022:</span> Cosmos has finally reached 75+ servers!
              </li>
              <li className="about-activity">
                 <span className="purple">02/03/2022:</span> Version 1.0 has been launched!
              </li>
            </ul>
          </p>
          <p className="home-about-body"><span className="purple">Versions:</span><p style={{fontSize: "0.8em"}}>(<span className="yellow">commands</span>, <span className="green">the lines of python code</span>)</p></p>
          <ul>
            <li className="about-activity">
               <span className="purple">4.9.0</span> - Complete log system, APOD issues are fixed. (<span className="yellow">22</span>, <span className="green">1016</span>)
            </li>
            <li className="about-activity">
               <span className="purple">4.8.0</span> - Re-supported outdated commands. (<span className="yellow">22</span>, <span className="green">1003</span>)
            </li>
            <li className="about-activity">
               <span className="purple">4.7.0</span> - APOD and bug fixes (<span className="yellow">22</span>, <span className="green">1045</span>)
            </li>
            <li className="about-activity">
               <span className="purple">4.6.0</span> - Bug fixes (<span className="yellow">22</span>, <span className="green">1011</span>)
            </li>
            <li className="about-activity">
               <span className="purple">4.5.0</span> - 2 services added, removed unsupported commands (<span className="yellow">22</span>, <span className="green">1020</span>)
            </li>
            <li className="about-activity">
               <span className="purple">4.4.0</span> - Apod service update, bug fixes (<span className="yellow">26</span>, <span className="green">1019</span>)
            </li>
            <li className="about-activity">
               <span className="purple">4.3.0</span> - Updated astronomy database, rewrote /find, /epic (<span className="yellow">26</span>, <span className="green">972</span>)
            </li>
            <li className="about-activity">
               <span className="purple">4.2.0</span> - Added a new command (<span className="yellow">27</span>, <span className="green">900</span>)
            </li>
            <li className="about-activity">
               <span className="purple">4.1.0</span> - Fixed /apod, topgg server status (<span className="yellow">26</span>, <span className="green">850</span>)
            </li>
            <li className="about-activity">
               <span className="purple">4.0.0</span> - Removed news service/command re-added insight(<span className="yellow">26</span>, <span className="green">850</span>)
            </li>
            <li className="about-activity">
               <span className="purple">3.9.0</span> - Removed geoidheight and gravity anomaly command (<span className="yellow">26</span>, <span className="green">910</span>)
            </li>
            <li className="about-activity">
               <span className="purple">3.8.0</span> - Removed insight command (<span className="yellow">28</span>, <span className="green">956</span>)
            </li>
            <li className="about-activity">
               <span className="purple">3.7.0</span> - Stabilized network (<span className="yellow">29</span>, <span className="green">979</span>)
            </li>
            <li className="about-activity">
               <span className="purple">3.6.0</span> - Major bug fixes, topgg server status (<span className="yellow">29</span>, <span className="green">968</span>)
            </li>
            <li className="about-activity">
               <span className="purple">3.5.1</span> - Removed unused commands, fixed APOD (<span className="yellow">29</span>, <span className="green">950</span>)
            </li>
            <li className="about-activity">
               <span className="purple">3.5.0</span> - Full refactory + new commands (<span className="yellow">31</span>, <span className="green">972</span>)
            </li>
            <li className="about-activity">
               <span className="purple">3.4.0</span> - New commands + refactory (<span className="yellow">29</span>, <span className="green">899</span>)
            </li>
            <li className="about-activity">
               <span className="purple">3.3.0</span> - Command rewrites (<span className="yellow">29</span>, <span className="green">927</span>)
            </li>
            <li className="about-activity">
               <span className="purple">3.2.0</span> - New command/service + rewrites (<span className="yellow">30</span>, <span className="green">929</span>)
            </li>
            <li className="about-activity">
               <span className="purple">3.1.0</span> - New command (<span className="yellow">30</span>, <span className="green">871</span>)
            </li>
            <li className="about-activity">
               <span className="purple">3.0.0</span> - New/updated commands (<span className="yellow">29</span>, <span className="green">790</span>)
            </li>
            <li className="about-activity">
               <span className="purple">2.9.0</span> - Removed Astronomy-database, migrated to nextcord (<span className="yellow">28</span>, <span className="green">743</span>)
            </li>
            <li className="about-activity">
               <span className="purple">2.8.0</span> - Optimization of commands (<span className="yellow">33</span>, <span className="green">947</span>)
            </li>
            <li className="about-activity">
               <span className="purple">2.7.0</span> - New commands, APOD service (<span className="yellow">33</span>, <span className="green">930</span>)
            </li>
            <li className="about-activity">
               <span className="purple">2.6.0</span> - Celestial / API improvment, new commands (<span className="yellow">29</span>, <span className="green">787</span>)
            </li>
            <li className="about-activity">
               <span className="purple">2.5.0</span> - Stabilized Cosmos (<span className="yellow">27</span>, <span className="green">740</span>)
            </li>
            <li className="about-activity">
               <span className="purple">2.4.0</span> - API speed up (<span className="yellow">27</span>, <span className="green">730</span>)
            </li>
            <li className="about-activity">
               <span className="purple">2.3.0</span> - Bug fixes, code rewrite (<span className="yellow">27</span>, <span className="green">735</span>)
            </li>
            <li className="about-activity">
               <span className="purple">2.2.0</span> - Deleted/added commands (<span className="yellow">28</span>, <span className="green">795</span>)
            </li>
            <li className="about-activity">
               <span className="purple">2.1.0</span> - New commands, full test (<span className="yellow">29</span>, <span className="green">801</span>)
            </li>
            <li className="about-activity">
               <span className="purple">2.0.0</span> - Switched to slash commands (<span className="yellow">27</span>, <span className="green">790</span>)
            </li>
            <li className="about-activity">
               <span className="purple">1.9.0</span> - Rewrote for privacy policy (<span className="yellow">28</span>, <span className="green">971</span>)
            </li>
            <li className="about-activity">
               <span className="purple">1.8.0</span> - New commands, bug fixes(<span className="yellow">28</span>, <span className="green">974</span>)
            </li>
            <li className="about-activity">
               <span className="purple">1.7.0</span> - New command (<span className="yellow">26</span>, <span className="green">917</span>)
            </li>
            <li className="about-activity">
               <span className="purple">1.6.0</span> - Bug fixes (<span className="yellow">25</span>, <span className="green">891</span>)
            </li>
            <li className="about-activity">
               <span className="purple">1.5.0</span> - Supported version (<span className="yellow">25</span>, <span className="green">810</span>)
            </li>
            <li className="about-activity">
               <span className="purple">1.4.0</span> - Major bug fixes, full test (<span className="yellow">25</span>, <span className="green">805</span>)
            </li>
            <li className="about-activity">
               <span className="purple">1.3.0</span> - New commands, full grammer check/rewrite (<span className="yellow">25</span>, <span className="green">805</span>)
            </li>
            <li className="about-activity">
               <span className="purple">1.2.0</span> - New command, bug fixes (<span className="yellow">17</span>, <span className="green">641</span>)
            </li>
            <li className="about-activity">
               <span className="purple">1.1.0</span> - New commands, bug fixes (<span className="yellow">16</span>, <span className="green">644</span>)
            </li>
            <li className="about-activity">
               <span className="purple">1.0.0</span> - First launched version of Cosmos (<span className="yellow">13</span>, <span className="green">585</span>)
            </li>
          </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default About;
